import { createFileRoute, useParams } from '@tanstack/react-router';
import { MyCertificationDetailContent, useGetMySpecialtyCertificationDetail } from '../../../../-shared';
export const Route = createFileRoute('/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout/_index/')({
  component: MySpecialtyCertificationDetail
});
function MySpecialtyCertificationDetail() {
  const {
    id
  } = useParams({
    from: '/_individual/individual/_profile/certifications/specialty-certifications/$id/_layout/_index/'
  });
  const queryResult = useGetMySpecialtyCertificationDetail(id);
  return <MyCertificationDetailContent {...queryResult} />;
}